function getMostPopularPackage<
  T extends { meta?: { mostPopular?: boolean } },
  P extends Record<string, T>,
>(packages: P): T | null {
  return (
    Object.values(packages).find((packageConfig: T) => packageConfig.meta?.mostPopular) || null
  );
}

export default getMostPopularPackage;
